import {
  takeLatest, call, put,
} from 'redux-saga/effects';

import { loginRequest, loginSuccess, loginFailure } from '../../slices/user';
import axios from '../axiosConfig';

function* loginWorker(action) {
  try {
    const { email, password } = action.payload;
    // eslint-disable-next-line no-undef
    const data = new FormData();
    data.append('username', email);
    data.append('password', password);
    const config = {
      method: 'post',
      url: '/users/login',
      data,
    };
    const response = yield call(axios, config);
    if (response.data) {
      yield put(loginSuccess({ response: response.data, email }));
      const expiryDate = new Date();
      expiryDate.setSeconds(expiryDate.getSeconds() + response.data.expiresIn);
      localStorage.setItem('user', JSON.stringify({ accessToken: response.data.accessToken, expiryDate, email }));
      axios.defaults.headers.Authorization = `Bearer ${response.data.accessToken}`;
    } else throw new Error();
  } catch (e) {
    yield put(loginFailure('Cannot log in with such email-password pair'));
  }
}

function* loginWatcher() {
  yield takeLatest(loginRequest.toString(), loginWorker);
}

export default loginWatcher;
